import { render, staticRenderFns } from "./Localed.vue?vue&type=template&id=8024a380&"
import script from "./Localed.vue?vue&type=script&lang=js&"
export * from "./Localed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports